import script from "./uploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadFile.vue?vue&type=script&setup=true&lang=js"

import "./uploadFile.vue?vue&type=style&index=0&id=66c0081c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c0081c"]])

export default __exports__